import { Box } from "@mui/material";
import { getAttachmentType, getAttachmentUrl } from "../messages-utils";

type Props = {
  attachments: any[];
  onImagePreview: (preview: { src: string; title?: string }) => void;
};

const MessageAttachments = ({ attachments, onImagePreview }: Props) => {
  if (!attachments.length) return null;

  return (
    <Box className="message-attachments">
      {attachments.map((file: any) => {
        const url = getAttachmentUrl(file);
        const kind = getAttachmentType(file);
        if (!url) return null;
        if (kind === "image") {
          return (
            <button
              key={file?._id || url}
              type="button"
              className="message-attachment-image-button"
              onClick={() =>
                onImagePreview({
                  src: url,
                  title: file?.title || file?.name || "Attachment",
                })
              }
              aria-label="Open image"
            >
              <img
                src={url}
                alt={file?.title || "Attachment"}
                className="message-attachment-image"
              />
            </button>
          );
        }
        if (kind === "audio") {
          return (
            <audio
              key={file?._id || url}
              controls
              src={url}
              className="message-attachment-audio"
            />
          );
        }
        return (
          <a
            key={file?._id || url}
            href={url}
            target="_blank"
            rel="noreferrer"
            className="message-attachment-link"
          >
            {file?.title || file?.name || "Attachment"}
          </a>
        );
      })}
    </Box>
  );
};

export default MessageAttachments;
